import { assetsPresentMap } from '../common';

export default function ({ row, status }: { row: any; status?: string }) {
  if (!status) return null;

  const copy = assetsPresentMap[status];
  if (!copy) return null;

  return <span>{copy}</span>;
}
